import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_58wn0038: FaireBrandEntity = {
  token: "b_58wn0038",
  type: "brand",
  name: "Laughing Giraffe",
  avatarUrl:
    "https://cdn.faire.com/fastly/747bb30c7f1e379977b1494ca56b8323837528f12d62d8748a0411cb1fee5d3e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/415090e1c67fbe800c0383b7acbe7a34829b7c6280f99412a6d0309dc4cfc3b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/747bb30c7f1e379977b1494ca56b8323837528f12d62d8748a0411cb1fee5d3e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/415090e1c67fbe800c0383b7acbe7a34829b7c6280f99412a6d0309dc4cfc3b7.png",
  location: "Santa Ana, CA, USA",
  minimumOrderDollars: 107,
  rating: 4.8,
  reviewCount: 236,
  isTopShop: true,
  isInsider: true,
  description:
    "The Laughing Giraffe ® and Neil & David®  specializes in Basic, Classic and Trendy Baby, Toddler, Youth and Adult Blank Clothing.\n\nFor safety and comfort all products are CPSIA certified. \n\n* 100% Cotton 7.2 oz interlock knit for Screen Printing, Tie-Dye, Embroidery, Monogram and Applique\n* 65% Polyester 35% Cotton 6.7oz interlock knit for Screen Printing, Embroidery & Sublimation Printing (Vintage look)\n* 100% Polyester 6.4oz interlock knit – Vivid Color Sublimation Printing \n* 100% Polyester 7.8oz Fleece-Lined - Vivid Color Sublimation Printing and Embroidery\n\nLaughing Giraffe (R) was created by Zoe Rock. She was frustrated with the low quality and lack of variety other blank companies provided. She started this company on her own and later brought her husband and son in to help it grow. We supply a full range baby and toddler blank clothing to imprinters & embroiderers who require special designs, colors and fabrics with consistent quality. \n\nWe have a wonderful staff of knowledgeable and friendly people here to help you with your blank clothing needs. We strive to make our customers happy and provide high quality clothing they can depend on time and time again. Our clothing is CPSIA approved and never made in a sweat-shop. We ship from Sunny Southern California and each order is hand packed with lots of love from our warehouse experts.\n\nOur mission statement is to earn your repeat business.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.886Z",
    importedBy: "entity-db-cli",
  },
};
